import type { FC, ReactElement, ReactNode } from 'react';

import { useModifiers } from '../../../styles/hooks/useModifiers';
import { IconButton } from '../../controls/iconButton/IconButton';

import styles from './NavBurger.module.css';

export interface NavBurgerPlainProps {
  isGhost?: boolean;
  isLarge?: boolean;
  isOpen?: boolean;
  isOverlaid?: boolean;
  isSmall?: boolean;
  navControls: ReactNode;
  navControlsCondition: boolean;
  navOpen?: boolean;
  onClick: () => void;
}

export const NavBurger: FC<NavBurgerPlainProps> = ({
  isGhost,
  isLarge,
  isOpen,
  isOverlaid,
  isSmall,
  navControls,
  navControlsCondition,
  navOpen,
  onClick,
}): ReactElement => {
  const mods = useModifiers(styles, 'navBurger', { open: navOpen, overlaid: isOverlaid });
  return (
    <div className={`${styles.nav__burgerContainer}${isOpen ? ` ${styles.nav__burgerContainer_open}` : ''}`}>
      {/* TODO: Understand why and comment*/}
      {navControlsCondition ? <div className={styles.nav__controls}>{navControls}</div> : ''}
      <div data-testid="nav-burger" className={`${styles.navBurger} ${mods}`}>
        <IconButton large={isLarge} small={isSmall} ghost={isGhost} onClick={onClick}>
          <div className={`${styles.navBurger__icon}`}>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </IconButton>
      </div>
    </div>
  );
};
